// extracted by mini-css-extract-plugin
module.exports = {"mobile-input-like-row":"mobile-input-like-row___3168h","value":"value___1zZaN","icon":"icon___35or2"};